import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import format from './i18n-format';



const debug = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: debug,
    supportedLngs: ["en", "fr", "pt"],
    fallbackLng: "en",
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    backend: {
      loadPath: "/assets/locale/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag", "path", "subdomain"],
      caches: ["localStorage"],
    },
    ns: "translation",
    defaultNS: "translation",
    initImmediate: true,
    interpolation: {
      format,
    },
  });

i18n.services.formatter?.add('DATE_CURRENT', (value, lng) => {
  return new Date(value).toLocaleDateString(lng);
});






export default i18n;